/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DnspForProject } from "./DnspForProject";
import {
    DnspForProjectFromJSON,
    DnspForProjectFromJSONTyped,
    DnspForProjectToJSON,
} from "./DnspForProject";

/**
 *
 * @export
 * @interface AccessTagsResponse
 */
export interface AccessTagsResponse {
    /**
     * True if this is the complete list of tags. This is the case if you are allowed to see all tags in the system (ie you are admin, or mineOnly=false)
     * @type {boolean}
     * @memberof AccessTagsResponse
     */
    isComplete?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof AccessTagsResponse
     */
    projectAccessTags?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof AccessTagsResponse
     */
    dnspAccessTags?: Array<string>;
    /**
     * The mapping of projects to DNSPs (eg, REVS has ActewAgl, JemenaProject has AusNet, Evo, Jemena, TasNetworks, United).
     * @type {Array<DnspForProject>}
     * @memberof AccessTagsResponse
     */
    dnspsForProjects?: Array<DnspForProject>;
}

/**
 * Check if a given object implements the AccessTagsResponse interface.
 */
export function instanceOfAccessTagsResponse(
    value: object,
): value is AccessTagsResponse {
    return true;
}

export function AccessTagsResponseFromJSON(json: any): AccessTagsResponse {
    return AccessTagsResponseFromJSONTyped(json, false);
}

export function AccessTagsResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AccessTagsResponse {
    if (json == null) {
        return json;
    }
    return {
        isComplete: json["isComplete"] == null ? undefined : json["isComplete"],
        projectAccessTags:
            json["projectAccessTags"] == null
                ? undefined
                : json["projectAccessTags"],
        dnspAccessTags:
            json["dnspAccessTags"] == null ? undefined : json["dnspAccessTags"],
        dnspsForProjects:
            json["dnspsForProjects"] == null
                ? undefined
                : (json["dnspsForProjects"] as Array<any>).map(
                      DnspForProjectFromJSON,
                  ),
    };
}

export function AccessTagsResponseToJSON(
    value?: AccessTagsResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        isComplete: value["isComplete"],
        projectAccessTags: value["projectAccessTags"],
        dnspAccessTags: value["dnspAccessTags"],
        dnspsForProjects:
            value["dnspsForProjects"] == null
                ? undefined
                : (value["dnspsForProjects"] as Array<any>).map(
                      DnspForProjectToJSON,
                  ),
    };
}
